export default __webpack_public_path__ + "static/2190-d2ad63ad5cd26079cd5de938dc87c061.gif";